<form [formGroup]="form" (ngSubmit)="submitFromParent()">
  <div class="mb-4">
    <label class="form-label">
      {{ 'rentalModule.rental' | translate }}
    </label>
    <product-select-input
      (search)="onSearchProducts($event)"
      [products]="rentalProducts$ | async"
      formControlName="productId"
      (productSelected)="productSelected($event)"
      [allowClearing]="false"
      [isFromBookingSaleCreation]="true"
      [dropdownPosition]="'top'"
    ></product-select-input>
    <p
      class="invalid-feedback"
      role="alert"
      aria-atomic="true"
      *ngIf="form.controls.productId.dirty && form.controls.productId.invalid"
    >
      {{ 'productModule.product' | translate }}
      {{ 'general.isInvalid' | translate }}
    </p>
  </div>

  <div class="mb-4">
    <label class="form-label">
      {{ 'general.quantity' | translate }}
    </label>
    <input
      type="number"
      class="form-control"
      placeholder="1"
      formControlName="quantity"
      min="1"
      [max]="selectedProduct?.rentalMaxConcurrent || null"
    />
    <p
      class="invalid-feedback"
      role="alert"
      aria-atomic="true"
      *ngIf="form.controls.quantity.dirty && form.controls.quantity.invalid"
    >
      {{ 'general.quantity' | translate }}
      {{ 'general.isInvalid' | translate }}
    </p>
  </div>

  <div class="row">
    <fieldset class="mb-4 col-md-auto">
      <legend class="form-label">
        {{ 'rentalModule.rentedFrom' | translate }}
      </legend>
      <datetime-input
        formControlName="rentStartDate"
        [minDate]="getCurrentDate()"
      ></datetime-input>
      <p
        class="invalid-feedback"
        role="alert"
        aria-atomic="true"
        *ngIf="
          form.controls.rentStartDate.dirty &&
          form.controls.rentStartDate.invalid
        "
      >
        {{ 'general.startDate' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </fieldset>

    <fieldset class="mb-4 col-md-auto">
      <legend class="form-label">
        {{ 'rentalModule.rentedTill' | translate }}
      </legend>
      <datetime-input
        formControlName="rentEndDate"
        [minDate]="form.value.rentStartDate || getCurrentDate()"
      ></datetime-input>
      <p
        class="invalid-feedback"
        role="alert"
        aria-atomic="true"
        *ngIf="
          form.controls.rentEndDate.dirty && form.controls.rentEndDate.invalid
        "
      >
        {{ 'general.endDate' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </fieldset>
  </div>

  <p class="invalid-feedback d-block" role="alert" *ngIf="dateError">
    {{ 'rentalModule.rentalPeriod' | translate }}
    {{ 'general.isInvalid' | translate }}
  </p>

  <div class="mt-3" *ngIf="productIsRentedOut">
    <p>{{ 'rentalModule.productIsRentedOut' | translate }}</p>
    <p *ngIf="nextAvailableRentalDate">
      {{ 'rentalModule.nextAvailableRentalDate' | translate }}
      {{ nextAvailableRentalDate | formatDate: 'd MMM y HH:mm' | async }}
    </p>
  </div>
</form>
